import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Dialog, DialogContent } from '@mui/material';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';

const MobileGuard = ({ children }) => {
    const ANDROIDAPPLINK = 'https://sama-tech.ae/apk/MOEI-CRM-APP-2.1.5.apk';
    const IPHONEAPPLINK = 'https://apps.apple.com/ae/app/moei-crm/id6754836564';
    const IPHONE = 'iphone';
    const ANDROID = 'android';

    const [isMobile, setIsMobile] = useState(false);
    const [mobileBrand, setIsMobileBrand] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            const userAgent = /Android|iPhone/i.test(navigator.userAgent);
            const isSmallScreen = window.innerWidth <= 768;
            setIsMobile(userAgent );
            setIsMobileBrand(navigator.userAgent);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    if (false) {
        return (
            <Box
                sx={{
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    backgroundColor: '#f5f5f5',
                    p: 3
                }}
            >
                <AppRegistrationIcon sx={{ fontSize: 80, color: 'primary.main', mb: 2 }} />
                <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ fontSize:'2rem',fontFamily: 'Almarai, sans-serif' }}>
                    عذراً، يرجى استخدام التطبيق
                </Typography>
                <Typography variant="body1" sx={{ fontSize:'1.5rem' ,mb: 4, color: 'text.secondary', fontFamily: 'Almarai, sans-serif' }}>
                    للحصول على أفضل تجربة لمتابعة مهام النقل ، يرجى تحميل تطبيقنا المخصص للهواتف.
                </Typography>

                <Button
                    variant="contained"
                    size="large"
                    href={mobileBrand == IPHONE ? IPHONEAPPLINK : ANDROIDAPPLINK}
                    sx={{ fontSize:'1.5rem',borderRadius: 10, px: 5, fontFamily: 'Almarai, sans-serif' }}
                >
                    تحميل التطبيق الآن
                </Button>
            </Box>
        );
    }

    return children;
};

export default MobileGuard;